import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { ActivatedRoute } from '@angular/router';
import { page }  from '../class/status';
import { environment } from '../../../environments/environment';
import { menulist }  from '../class/status';
import { Rtable } from '../class/rtabledata';
import { chartdata }  from '../class/chatdata';
import * as Highcharts from 'highcharts';
import { Options } from "highcharts";

@Component({
  selector: 'app-useractive',
  templateUrl: './useractive.component.html',
  styleUrls: ['./useractive.component.css']
})
export class UseractiveComponent implements OnInit {
    Highcharts: typeof Highcharts = Highcharts;
    updateFlag:boolean=false;

    @Output() notify = new EventEmitter<any>();
    now:string = '0';
    subnow:string = '0';
    chat_obj = {me:'-1',mename:'',mepic:'',to:'-1',toname:'',topic:''};
    reward_num:number = 0;
    power:number = 0;
    trade_num_info:any=[];
    packet:number=0;
    age_info:any=[];
    emp_info:any=[];
    user:any={};
    flag:any={};
    areaOptions: Options = JSON.parse(JSON.stringify(chartdata.area_bar));
    areaOptions2: Options = JSON.parse(JSON.stringify(chartdata.area_bar));
    areaOptions3: Options = JSON.parse(JSON.stringify(chartdata.area_bar));
    areaOptions4: Options = JSON.parse(JSON.stringify(chartdata.area_bar));
    gender:any = 3;
  cancel_user_tmp:boolean=false;

  gender_list:any[] = [
    { "id": '-1', "name": "全部" },
    { "id": '1', "name": "男" },
    { "id": '2', "name": "女" },
  ]

  order_option: any[] = [
  { "id": 'create_dt', "name": "註冊日期" },
  { "id": 'tel_time', "name": "通話時長" },
  { "id": 'send_chats_num', "name": "傳送訊息數量" },
  { "id": 'receve_chats_num', "name": "接收訊息數輛" },
  { "id": 'last_singin_date', "name": "最後登入日" }, 
  { "id": 'money', "name": "出入金" }, 
];
  posts_attributes:any=[];
  posts_input:any=[];

  constructor(
    public httpClient: HttpClient,
    private  route: ActivatedRoute,
  ){}

  ngOnInit(): void {
    if(this.route.snapshot.paramMap.get('id')){
      this.search_model = this.route.snapshot.paramMap.get('id');
    }
    if(this.route.snapshot.paramMap.get('view')){
      this.view = this.route.snapshot.paramMap.get('view');
    }

    this.init_list();
    /*
      交易紀錄
      登入紀錄
      聊天列表
    */
       
    this.power = Dep.auth.power_id;
    this.user = Dep.user;
  }
  menu_list:menulist = [{id:'0',name:'用戶活躍度'},{id:'1',name:'地區活躍度'},{id:'2',name:'聊天列表'}]

  sort_obj:any = {column:'create_dt',sort:'0'}
  link:string = environment.link;
  view:string = '-1';
  search_gender:string = '-1';
  search_country:string = '-1';
  search_chat_list:string = '';//聊天列表用的搜尋
  search_model:string = '';
  data:any=[];
  chat_list_data:any=[];
  edit_data:any=[];
  detail_data:any=[];
  country_list:any=[];
  loading:boolean=true;
  msg :string = '';
  pageobj:page = {page:0,count:10,total_count:0};
  pageobj2:page = {page:0,count:20,total_count:0};
  pageobj3:page = {page:0,count:20,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  pageobjstr2:string=JSON.parse(JSON.stringify(this.pageobj2))
  pageobjstr3:string=JSON.parse(JSON.stringify(this.pageobj3))
  fuck_item:any={}
  showLink: any = [];
  hideTimer: any;

init_chart(item){
    this.gender = item.gender;
    this.areaOptions.title.text = '每月取得';
    this.areaOptions2.title.text = '每月花費';
    this.areaOptions3.title.text = '過去四週取得';
    this.areaOptions4.title.text = '過去四週花費';

    if (Array.isArray(this.areaOptions.yAxis)) {
        this.areaOptions.yAxis.forEach(yAxis => {
            yAxis.accessibility = { description: '每月取得鑽石數' };
        });
    } else {
        this.areaOptions.yAxis.accessibility = { description: '每月取得鑽石數' };
    }
    
    
    if (Array.isArray(this.areaOptions2.yAxis)) {
        this.areaOptions2.yAxis.forEach(yAxis => {
            yAxis.accessibility = { description: '每月花費鑽石數' };
        });
    } else {
        this.areaOptions2.yAxis.accessibility = { description: '每月花費鑽石數' };
    }

    if (Array.isArray(this.areaOptions3.yAxis)) {
        this.areaOptions3.yAxis.forEach(yAxis => {
            yAxis.accessibility = { description: '過去四週取得鑽石數' };
        });
    } else {
        this.areaOptions3.yAxis.accessibility = { description: '過去四週取得鑽石數' };
    }

    if (Array.isArray(this.areaOptions4.yAxis)) {
        this.areaOptions4.yAxis.forEach(yAxis => {
            yAxis.accessibility = { description: '過去四週花費鑽石數' };
        });
    } else {
        this.areaOptions4.yAxis.accessibility = { description: '過去四週花費鑽石數' };
    }

    const body = {id:item.user_id};
    this.httpClient.post<any>("/get_user_spend_list.php",body).subscribe(res => {
        this.loading = false;
        if (res.monthdata) {

            //每月取得
                // 使用map方法轉換日期
            let transformedData = res.monthdata.map(item => {
                let dateStr = item[0];
                let value = item[1];
                let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                return [timestamp, value];
            });
       
            let monthincome:any= {
                name: '每月取得鑽石數',
                data: transformedData,
                lineColor: Highcharts.getOptions().colors[1],
                color: Highcharts.getOptions().colors[2],
                fillOpacity: 0.5,
                marker: {
                    enabled: false
                },
                threshold: null,
                dataLabels: {
                    enabled: true,  // 啟用數據標籤
                    formatter: function () {
                        return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                    },
                }
            };
            this.areaOptions.series = [monthincome];

            //每月花費
             // 使用map方法轉換日期
             let transformedData2 = res.monthconsume.map(item => {
                let dateStr = item[0];
                let value = item[1];
                let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                return [timestamp, value];
            });
         
            let monthconsume:any= {
                name: '每月花費鑽石數',
                data: transformedData2,
                lineColor: Highcharts.getOptions().colors[1],
                color: Highcharts.getOptions().colors[3],
                fillOpacity: 0.5,
                marker: {
                    enabled: false
                },
                threshold: null,
                dataLabels: {
                    enabled: true,  // 啟用數據標籤
                    formatter: function () {
                        return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                    },
                }
            };
            this.areaOptions2.series = [monthconsume];
        }

        if (res.weekdata) {
            //過去四周取得
             // 使用map方法轉換日期
             let transformedData3 = res.weekdata.map(item => {
                let dateStr = item[0];
                let value = item[1];
                let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                return [timestamp, value];
            });
         
            let weekincome:any= {
                name: '過去四週取得鑽石數',
                data: transformedData3,
                lineColor: Highcharts.getOptions().colors[1],
                color: Highcharts.getOptions().colors[4],
                fillOpacity: 0.5,
                marker: {
                    enabled: false
                },
                threshold: null,
                dataLabels: {
                    enabled: true,  // 啟用數據標籤
                    formatter: function () {
                        return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                    },
                }
            };

            
            this.areaOptions3.xAxis = {
                type: 'datetime',
                labels: {
                    format: '{value:%Y-%m-%d}' // Format the date as "YYYY-MM-DD"
                },
                title: {
                    text: '日期'
                }
            };

            this.areaOptions3.tooltip = {
                headerFormat: '<strong>Date: {point.key:%Y-%m-%d}</strong><br>',
                pointFormat: '{point.y}',
                shared: true
            };

            this.areaOptions3.series = [weekincome];


             //過去四周花費
             // 使用map方法轉換日期
             let transformedData4 = res.weekconsume.map(item => {
                let dateStr = item[0];
                let value = item[1];
                let timestamp = new Date(dateStr).getTime(); // 將日期轉換為毫秒時間戳
                return [timestamp, value];
            });
         
            let weekincome2:any= {
                name: '過去四週花費鑽石數',
                data: transformedData4,
                lineColor: Highcharts.getOptions().colors[1],
                color: Highcharts.getOptions().colors[5],
                fillOpacity: 0.5,
                marker: {
                    enabled: false
                },
                threshold: null,
                dataLabels: {
                    enabled: true,  // 啟用數據標籤
                    formatter: function () {
                        return Highcharts.numberFormat(this.y, 0, '.', ','); // Custom formatting
                    },
                }
            };

            
            this.areaOptions4.xAxis = {
                type: 'datetime',
                labels: {
                    format: '{value:%Y-%m-%d}' // Format the date as "YYYY-MM-DD"
                },
                title: {
                    text: '日期'
                }
            };

            this.areaOptions4.tooltip = {
                headerFormat: '<strong>Date: {point.key:%Y-%m-%d}</strong><br>',
                pointFormat: '{point.y}',
                shared: true
            };

            this.areaOptions4.series = [weekincome2];
        }
        this.updateFlag = true;
    });
    
}

  get_chat(item){

    this.pageobj3.page=0;
    this.now='2';


    this.chat_obj.me = item.uid;
    this.chat_obj.mename = item.name;
    this.chat_obj.mepic = item.profile_pic;
    this.chat_list();
  }


  ch_menu(now){
    this.sort_obj.sort = '0';
    this.now = now;
    this.pageobj.page=0;
    this.chat_obj.me = '-1'
    if(now==0){
      this.sort_obj.column = 'last_singin_date'
    }else{
      this.sort_obj.column = 'rece_diamond_all'
    }
    this.init_list();
  }

  init_attributes(){
    let tmp_data = {};
    if(this.now == '0'){
      Rtable.structure.type = 'txt';
      tmp_data = {
        name:{name:'姓名',type:'opt'},
        phone_num:{name:'電話'},
        profile_pic:{name:'大頭貼',type:'opt',title_cls_mb:'none'},
        money:{name:'儲值/出金',type:'num',unit:'元',sort:1},
        diamond:{name:'收/支鑽',type:'opt',sort:1},
        tel_time:{name:'通話時長',sort:1},
        tel_rate:{name:'通話率',sort:1},
        reject_rate:{name:'拒接率',sort:1},
        send_chats_num:{name:'訊息(送)',type:'opt',sort:1},
        receve_chats_num:{name:'訊息(收)',type:'opt',sort:1},
        active_time:{name:'活躍時段'},
        trade_people_num:{name:'交易人次',type:'num',sort:1},
        last_singin_date:{name:'登入',type:'opt',sort:1},
        create_dt:{name:'註冊',sort:1},
      }
    }else if(this.now == '1') {
      Rtable.structure.type = 'num';
      tmp_data = {
        cname:{name:'國家',type:'txt'},
        deposit_all:{name:'總儲值',unit:'元',sort:1},
        withdrawal_all:{name:'總提領',unit:'元',sort:1},
        rece_diamond_all:{name:'總賺鑽石',unit:'鑽',sort:1},
        cust_diamond_all:{name:'總花鑽石',unit:'鑽',sort:1},
        rece_chat_all:{name:'總收訊息',sort:1},
        send_chat_all:{name:'總送訊息',sort:1},
        tel_time:{name:'總語音時間',type:'txt',sort:1},
      }
    }
    this.posts_attributes = Rtable.init(tmp_data);
  }

  chat_list(){
    this.loading = true;
    const body = {page: this.pageobj3.page,count:this.pageobj3.count,
    search_chat_list:this.search_chat_list,
    sort_obj:this.sort_obj,
    me:this.chat_obj.me,
   
  
    };
    this.httpClient.post<any>("/get_user_chat_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.chat_list_data = res.data;
        this.pageobj3.total_count = res.total_count
      }else{
        this.pageobj3.total_count = 0
        this.chat_list_data = [];
      }
      this.pageobjstr3=JSON.parse(JSON.stringify(this.pageobj3))
      window.setTimeout(()=>{
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },150)
     
      console.log('res',res);
    });
  }

  onScroll(){
    var container = document.getElementById('chat_box');
    if(container.scrollTop < 300){
      let ori_height = container.scrollHeight;
      clearTimeout(this.flag);
      this.flag = window.setTimeout(()=>{
        this.packet ++;
        this.select_user(this.edit_data);
        window.setTimeout(()=>{
          let container2 = document.getElementById('chat_box');
          let new_height = container2.scrollHeight;
          container.scrollTop = new_height - ori_height;
        },400);
       
      },800)
     
    }
   
  }

  select_user(item){
    this.edit_data = item
    let scoll_bar_status = false;
    if(this.packet==0){
      scoll_bar_status = true;
      this.detail_data = [];
    }


    this.chat_obj.to = item.user_uid;
    this.loading = true;
    const body = {page: this.pageobj2.page,count:this.pageobj2.count,
    search:this.search_model,
    sort_obj:this.sort_obj,
    meuid:this.chat_obj.me,
    uid:this.chat_obj.to,
    packet:this.packet,
  
    };
    this.httpClient.post<any>("/get_user_chat_record.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.subnow = '3';
        this.detail_data = res.data.concat(this.detail_data);
        this.packet = res.packet;

        window.setTimeout(()=>{
          if(scoll_bar_status){
            var container = document.getElementById('chat_box');
            container.scrollTop = container.scrollHeight;
          }
        },250)
       
   
      }else{
        if(scoll_bar_status){//page1在清除
          this.detail_data = [];
        }
       
      }
      console.log('res',res);     
    });
  }

  async init_list() {
  if (!this.loading) {
    this.loading = true;
  }

  const body = {
    page: this.pageobj.page,
    count: this.pageobj.count,
    search: this.search_model,
    sort_obj: this.sort_obj,
    country: this.search_country,
    gender: this.search_gender,
    action: this.now,
  };

  try {
    const res = await this.httpClient.post<any>("/get_behavor_list.php", body).toPromise();

    if (this.loading) {
      this.loading = false;
    }

    this.country_list = res.country_list;

    if (res.status) {
        this.data = res.data;

        this.showLink = Object.keys(this.data).reduce((acc, key) => {
            acc[key] = false;
            return acc;
        }, {});

        this.pageobj.total_count = res.total_count;
        this.init_attributes();
    } else {
        this.pageobj.total_count = 0;
        this.data = [];
    }

    this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
    this.posts_input = {
      attribute: this.posts_attributes,
      content: this.data,
      sort_obj: this.sort_obj, // clone一份避免被rtable改掉
    };

    console.log('res', res);

    await new Promise(resolve => setTimeout(resolve, 100));

    if (this.view === '0') {
      $("#ggwp0").click();
    } else if (this.view === '1') {
      $("#ggwp1").click();
    }
  } catch (error) {
    console.error('Error:', error);
  }
}

  cancel_user(){
    this.cancel_user_tmp = true;
    this.chat_obj.me='-1';
    this.now='0';
  }

  get_trade_record(item:any){
    this.fuck_item = item;
    this.loading = true;
    const body = {page: this.pageobj2.page,count:this.pageobj2.count,
    user_id:item.user_id,  
  
    };
    this.httpClient.post<any>("/get_trade_record.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.edit_data = res.data;
        this.trade_num_info = res.trade_num_info;
        this.pageobj2.total_count = res.total_count;
      }else{
        this.edit_data = [];
        this.trade_num_info = {earn:0,pay:0};
        this.pageobj2.total_count = 0
      }
      this.pageobjstr2=JSON.parse(JSON.stringify(this.pageobj2))
      console.log('res',res);
    });  
  }




  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      if(this.cancel_user_tmp){
        window.setTimeout(()=>{
          this.cancel_user_tmp = false;
        },200)
       
      }else{
        if(!this.cancel_user_tmp){
          this.pageobj = pageobj;
        }
      }
      this.init_list();
    }
  }
  callback2(pageobj:page){
    if(JSON.stringify(this.pageobj2)!=JSON.stringify(pageobj)){
      this.pageobj2 = pageobj;
      this.get_trade_record(this.fuck_item);
    }
  }
  callback_chat(pageobj:page){
    if(JSON.stringify(this.pageobj3)!=JSON.stringify(pageobj)){
      this.pageobj3 = pageobj;
      this.chat_list();
    }
  }

    startHideTimer(id) {
        this.hideTimer = setTimeout(() => {
            this.showLink[id] = false;
        }, 5000);
    }
  
    cancelHideTimer() {
        clearTimeout(this.hideTimer); // 取消隐藏计时器
    }

}
